export default __webpack_public_path__ + "static/media/karthika.302cbf3d.png";